import React from 'react'
import Img from 'gatsby-image'
import Slider from './Slider'

class Gallery extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Slider>
        {this.props.images.map((object, key) => {
          if (object.image.localFile != null) {
            return <Img key={key} sizes={object.image.localFile.childImageSharp.sizes} />
          }
        })}
      </Slider>
    )
  }
}

export default Gallery


// WEBPACK FOOTER //
// ./src/components/Gallery.js